import React from "react";
import Grid from "@mui/material/Grid";
import CircleIcon from "../CircleIcon/CircleIcon";
import iconPdf from "../../assets/icon/picture_as_pdf-24px.svg";
import iconAttachment from "../../assets/icon/attach_file-24px.svg";
import iconImage from "../../assets/icon/collections-24px.svg";
import PopUpMenu from "../PopUpMenu/PopUpMenu";
import MenuItem from "@mui/material/MenuItem";
import { getMediaObjectSize } from "../../services/formServiceFunctions";
import { getCreatedBy } from "../../services/backofficeUserService";
import MediaObjectChips from "./MediaObjectChips";
import DisplayOrDownloadMediaObjectWrapper from "../ElectronicFileFolder/DisplayOrDownloadMediaObjectWrapper";
import { Box, Tooltip } from "@mui/material";
import { useBackofficeUser } from "../../provider/BackofficeUserProvider";
import { Star } from "@mui/icons-material";
import mediaObjectStyle from "./mediaObjectStyle";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { MediaObject as MediaObjectType } from "../../types/MediaObject";
import MediaObjectPopUpMenu from "./MediaObjectPopUpMenu";
import dayjs from "dayjs";

type MediaObjectProps = {
  mediaObject: MediaObjectType;
  updateMediaObjects: Function;
  isNonInteractive?: boolean;
  handleOpenMediaObject: Function;
  folderStructureView?: boolean;
};

const MediaObject = ({
  mediaObject,
  updateMediaObjects,
  isNonInteractive = false,
  handleOpenMediaObject,
  folderStructureView = false,
}: MediaObjectProps) => {
  const currentUser = useCurrentUser();
  const { backofficeUsers } = useBackofficeUser();

  const getIconData = (mediaObject: MediaObjectType) => {
    if (mediaObject.isFavourite) {
      return { icon: <Star sx={{ color: "primary.main" }} />, type: "muiIcon" };
    }
    let icon = iconAttachment;

    switch (mediaObject.mimeType) {
      case "image/jpg":
      case "image/jpeg":
      case "image/png":
        icon = iconImage;
        break;
      case "application/pdf":
        icon = iconPdf;
        break;
      default:
        break;
    }
    return { icon: icon, type: "image" };
  };

  //need some sort of info if the user is an admin
  const isExternal = currentUser.isExternal;
  const isExternalEditAllowed = !isExternal || mediaObject.createdBy === currentUser["@id"];

  const createdAt = dayjs(mediaObject.created);
  const { icon, type } = getIconData(mediaObject);

  return (
    <Grid container wrap={"nowrap"}>
      <Grid sx={{ display: { xs: "none", sm: "block" }, ...mediaObjectStyle.icon }}>
        <CircleIcon icon={icon} type={type} />
      </Grid>
      <Grid sx={mediaObjectStyle.item}>
        <Grid container>
          <Grid size={12}>
            {!isNonInteractive ? (
              <DisplayOrDownloadMediaObjectWrapper
                mediaObject={mediaObject}
                setMediaObjectToDisplay={handleOpenMediaObject}
              >
                <Box sx={mediaObjectStyle.mediaObjectName}>{mediaObject.originalName}</Box>
              </DisplayOrDownloadMediaObjectWrapper>
            ) : (
              <Box sx={mediaObjectStyle.headline}>{mediaObject.originalName}</Box>
            )}
          </Grid>
          <Grid
            sx={{
              ...mediaObjectStyle.description,
              ...(mediaObject.isFavourite ? mediaObjectStyle.bold : {}),
            }}
            size={12}>
            {mediaObject.description}
          </Grid>
          <Grid>
            Hinzugefügt durch {getCreatedBy(mediaObject.createdBy, backofficeUsers)} am {createdAt.format("DD.MM.YYYY")}{" "}
            um {createdAt.format("HH:mm")} Uhr |{" "}
            {mediaObject.mimeType === "application/pdf" && mediaObject.downloadOriginalUrl !== null && (
              <Tooltip title="Automatisch komprimiertes PDF">
                <span role="img" aria-label="compressed">
                  🗜️
                </span>
              </Tooltip>
            )}{" "}
            {getMediaObjectSize(mediaObject.size)}
          </Grid>
          {!isExternal && (
            <Grid size={12}>
              <MediaObjectChips mediaObject={mediaObject} showFolder={!folderStructureView} />
            </Grid>
          )}
        </Grid>
      </Grid>
      {!isNonInteractive && isExternalEditAllowed && (
        <Grid>
          <MediaObjectPopUpMenu mediaObject={mediaObject} updateMediaObjects={updateMediaObjects} />
        </Grid>
      )}
      {isExternal && !isExternalEditAllowed && (
        <Grid>
          <PopUpMenu>
            <MenuItem component={"a"} download={true} href={mediaObject.downloadUrl}>
              Herunterladen
            </MenuItem>
          </PopUpMenu>
        </Grid>
      )}
    </Grid>
  );
};

export default MediaObject;
